import React from 'react';
import { Link } from 'react-router-dom';

function RefundPolicy() {
  return (
    <>
      <section class="contact-info-area pt-100 pb-70">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-sm-12">
              <h2>Refund & Cancellation Policy</h2>

              <div className="legalSection">
                <ul>
                  <li><i class="flaticon-check"></i>Cancellations are allowed within 1 day of placing an order.</li>
                  <li><i class="flaticon-check"></i>No cancellation once the order has been shipped.</li>
                  <li><i class="flaticon-check"></i>Perishable goods are non-cancellable.</li>
                  <li><i class="flaticon-check"></i>Defective or damaged items must be reported within 1 day of delivery.</li>
                  <li><i class="flaticon-check"></i>Approved refunds are processed within 2 days.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default RefundPolicy;
